import React, { useState, useMemo } from 'react';
import { Table } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import { CMS_QUERY_PROPERTIES_BY_LANDLORD } from './queries';
import { TableSearchInput } from 'common/components/table-filter-component';
import { getSafeHtml } from 'common/helpers/safeHtml';

const removeSpace = text => {
  if (text) {
    return text.trim() || null;
  }
  return text;
};

export default function PropertyReviewList(props) {
  const { landlordIds, excludePropertyIds, setExcludePropertyIds } = props;
  const { t } = useTranslation();

  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [queryFilter, setQueryFilter] = useState({ name: '' });
  const [showPropertyNameFilter, setShowPropertyFilter] = useState(false);

  const { data: propertiesData, loading: getPropertiesLoading } = useQuery(
    CMS_QUERY_PROPERTIES_BY_LANDLORD,
    {
      variables: {
        name: queryFilter.name || null,
        landlordIds: landlordIds,
        pageNumber: currentPageNumber,
        pageSize: 10,
      },
    },
  );

  const tableData = useMemo(() => {
    return propertiesData?.properties?.edges?.map(edge => edge.node) || [];
  }, [propertiesData]);

  const rowSelection = {
    selectedRowKeys: excludePropertyIds,
    onChange: selectedRowKeys => {
      setExcludePropertyIds(selectedRowKeys);
    },
  };

  const tableColumns = useMemo(() => {
    return [
      {
        title: t('cms.special_offer.column.property'),
        dataIndex: 'name',
        key: 'name',
        className: 'property-review-list__table__column-title--w-full',
        filterDropdown: (
          <TableSearchInput
            field="name"
            value={queryFilter.name || ''}
            onChange={(_fieldName, value) => {
              setQueryFilter(current => ({ ...current, name: removeSpace(value) }));
              setCurrentPageNumber(1);
              setShowPropertyFilter(false);
            }}
          />
        ),
        filterIcon: <SearchOutlined style={{ color: queryFilter.name ? '#38b2a6' : '#c8c9cb' }} />,
        filterDropdownVisible: showPropertyNameFilter,
        onFilterDropdownVisibleChange: view => {
          setShowPropertyFilter(view);
        },
      },
      {
        title: t('cms.special_offer.column.landlord'),
        dataIndex: 'landlord',
        key: 'landlord',
        render: (_text, record) => {
          return record?.landlord?.name || '';
        },
      },
    ];
  }, [showPropertyNameFilter]);

  const handleTableChange = pagination => {
    setCurrentPageNumber(pagination.current);
  };
  return (
    <div className="property-review-list">
      <p className="property-review-list__des">
        {getSafeHtml(t('cms.special_offer.map.modal.review_property_list.des'))}
      </p>
      <div className="property-review-list__table">
        <div className="property-review-list__table__custom-header">
          {landlordIds.length} Landlords Selected, {excludePropertyIds.length} Properties Exclude
        </div>
        <Table
          rowSelection={rowSelection}
          columns={tableColumns}
          className="table-list"
          dataSource={tableData}
          pagination={{
            total: propertiesData?.properties?.totalCount,
            current: currentPageNumber,
            pageSize: 10,
          }}
          loading={getPropertiesLoading}
          onChange={handleTableChange}
          rowKey="id"
        />
      </div>
    </div>
  );
}
